import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { dotXetHocVuApi } from "../../../api/xet-hoc-vu/dotXetHocVuApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { eDotXetHocVuActionIds, IDotXetHocVuActionTypes } from "../../action-types/xet-hoc-vu/IDotXetHocVuActions";
import { IDotXetHocVu } from "../../../model/response/xet-hoc-vu/IDotXetHocVu";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IDotXetHocVuUpdateTrangThaiRequest } from "../../../model/request/xet-hoc-vu/IDotXetHocVuUpdateTrangThaiRequest";
const mainAction = rootActions.xetHocVu.dotXetHocVu;


export function* dotXetHocVuSaga(): any {
    yield takeLatest(eDotXetHocVuActionIds.LOAD_START, loadWoker);
    yield takeEvery(eDotXetHocVuActionIds.SAVE_START, saveWorker);
    yield takeEvery(eDotXetHocVuActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eDotXetHocVuActionIds.UPDATE_TRANG_THAI_START, updateTrangThaiWorker);
}

function* loadWoker(): any {
    const res: IBaseResponse = yield call(dotXetHocVuApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS( toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải đợt xét học vụ"));
    }
}

function* saveWorker(action: IDotXetHocVuActionTypes): any {
    let res: IBaseResponse;
    const payload = action.payload as IDotXetHocVu;
    if (payload.id_dot_xet > 0) {
        res = yield call(dotXetHocVuApi.Update, payload.id_dot_xet, payload);
    } else {
        res = yield call(dotXetHocVuApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu đợt xét học vụ"));
    }
}

function* deleteWorker(action: IDotXetHocVuActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(dotXetHocVuApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa đợt xét học vụ"));
    }
}

function* updateTrangThaiWorker(action: IDotXetHocVuActionTypes): any {
    const payload = action.payload as IDotXetHocVuUpdateTrangThaiRequest;
    const res: IBaseResponse = yield call(dotXetHocVuApi.UpdateTrangThai, payload.id_dot_xet, payload);
    if (res.is_success) {
        yield put(mainAction.UPDATE_TRANG_THAI_SUCCESS(res.data));
    } else {
        yield put(mainAction.UPDATE_TRANG_THAI_ERROR(res.message ?? "Có lỗi khi cập nhật trạng thái đợt xét học vụ"));
    }
}